import React from "react";
import loader from "../Loader2/loader.gif";

interface Props {
  width?: string;
  height?: string;
}

const Loader: React.FC<Props> = ({ width = "100%", height = "100%" }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width,
        height,
      }}
    >
      <img
        src={loader}
        alt="Loading"
        style={{
          width,
          height,
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default Loader;
